var map = {
	"./audit.svg": 6223,
	"./audited.svg": 2667,
	"./barcode.svg": 1096,
	"./circleLoop.svg": 8429,
	"./claim.svg": 5618,
	"./collecting.svg": 8606,
	"./collective.svg": 7350,
	"./correction.svg": 8914,
	"./dept.svg": 741,
	"./farm.svg": 605,
	"./home.svg": 7397,
	"./insure.svg": 5478,
	"./monitor.svg": 1752,
	"./pin-fill.svg": 6325,
	"./pin.svg": 1268,
	"./report.svg": 2602,
	"./role.svg": 7531,
	"./tenan.svg": 425,
	"./user.svg": 5745
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1151;